import SDropdownMenu from '@semcore/ui/dropdown-menu';

export const DropdownMenu = SDropdownMenu;
